import { render, staticRenderFns } from "./batch-patients-data-use.html?vue&type=template&id=a80ad3d6&scoped=true&external"
import script from "./batch-patients-data-use.js?vue&type=script&lang=js&external"
export * from "./batch-patients-data-use.js?vue&type=script&lang=js&external"
import style0 from "./batch-patients-data-use.scss?vue&type=style&index=0&id=a80ad3d6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ad3d6",
  null
  
)

export default component.exports